import React from 'react';

/** @internal */
export var licenceIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.0215 20.7283L9.64649 16.3533C9.45149 16.1583 9.45149 15.8413 9.64649 15.6463C9.84149 15.4513 10.1585 15.4513 10.3535 15.6463L13.9785 19.2713L21.6265 10.6673C21.8095 10.4603 22.1255 10.4443 22.3325 10.6253C22.5385 10.8093 22.5575 11.1253 22.3735 11.3323L14.0215 20.7283Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 12H15V11H9V12Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 9H18V8H9V9Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26 30H12.973C13.941 29.279 14.65 28.227 14.899 27H29.858C29.411 28.72 27.858 30 26 30ZM5.99997 26V4C5.99997 3.228 5.69997 2.532 5.22097 2H24C25.103 2 26 2.897 26 4V26H15H14C14 28.206 12.206 30 9.99997 30C7.79397 30 5.99997 28.206 5.99997 26ZM30 26H27V4C27 2.343 25.657 1 24 1H3V2C4.103 2 5 2.897 5 4V26C5 28.761 7.239 31 10 31H26C28.761 31 31 28.761 31 26H30Z"
}));